import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LinkMappingTool } from 'src/app/enums/mapping';
import { SharedServiceService } from 'src/app/services/shared-service.service';

@Component({
  selector: 'app-tab-view-marchand',
  templateUrl: './tab-view-marchand.component.html',
  styleUrls: ['./tab-view-marchand.component.css']
})
export class TabViewMarchandComponent {
  title: any = "Titre restaurant";
  currentUrl: string = '';
  message!: string;
  activeTabIndex: number = 0;
  
    constructor(private sharedService: SharedServiceService,private router: Router) {
    }
    ngOnInit() {  
      this.currentUrl = this.router.url;
      this.sharedService.changeMessage(LinkMappingTool.mapValue(this.currentUrl))
      this.sharedService.currentMessage.subscribe(message => this.message = message);
    }
    messageDuParent(type: string) :string{
  
      return type;
    }
  
    onTabChange(event: any) {
      this.activeTabIndex = event.index;
    }

    selectTab(index: number) {
  this.activeTabIndex = index;
}
}
